<app-loading *ngIf="contentReady"></app-loading>



<div class="bg-light" style="margin-bottom: 80px;">
  <div class="container-fluid">
    <div class="row justify-content-center" style="padding: 0!important;">

      
      <app-atw ngSkipHydration style="padding: 0!important;"></app-atw>
      <!-- <app-atw-cv-uploader style="padding: 0!important;"></app-atw-cv-uploader> -->
            <app-jobsinhome ngSkipHydration style="padding: 0!important;"></app-jobsinhome>
            <app-forcompany></app-forcompany>
            <app-statistics></app-statistics>
            <app-whyus></app-whyus>
                            <app-ourpartners ></app-ourpartners>
      <app-blogs></app-blogs>
       <app-allreviews></app-allreviews>
      <!-- <app-offers style="padding: 0!important;"></app-offers> -->
      <!-- <app-luckywheel *ngIf="showWheel" [userId]="userId">
      </app-luckywheel> -->




    </div>

  </div>
</div>